import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import London from "@/pages/London";
import { Toaster } from "@/components/ui/sonner";
import { initAnalytics } from "@/lib/analytics";

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/private-personal-trainer-london" element={<London />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111111",
            color: "#f4f4f0",
            border: "1px solid #27272a",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
